import Model from "./Model";

export default class Store extends Model {
  resource() {
    return "stores";
  }
}
